import { DASH } from "@/constants/testIds";

export default function TariffCallout({ spikes }) {
  if (!spikes || spikes.length === 0) return null;
  return (
    <div
      data-testid={DASH.tariffCallout}
      className="flat-card p-5 sm:p-6 border-l-4 border-l-[#B24F35] bg-[#FAF6F1]"
    >
      <div className="overline mb-2">Tariff shift · Detected</div>
      <div className="font-display text-lg mb-2">
        Your cost-per-kWh jumped {spikes.length === 1 ? "in one month" : `${spikes.length} times`}.
      </div>
      <ul className="text-sm font-mono-data text-[#1A1B1A] space-y-1">
        {spikes.map((s, i) => (
          <li key={i} className="flex justify-between">
            <span>{s.month_label}</span>
            <span className="text-[#B24F35]">
              RM {s.from_cpk.toFixed(4)} → RM {s.to_cpk.toFixed(4)} (+{s.jump_pct}%)
            </span>
          </li>
        ))}
      </ul>
      <p className="text-xs text-[#6E716C] mt-3">
        TNB revised tariffs on 1 July 2025. Large jumps often mean the AFA (adjustment factor) or a tariff-band change.
      </p>
    </div>
  );
}
